import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './IntroSection.css';

const IntroSection = () => {
  const { t } = useTranslation();

  return (
    <section className="intro-section" id="intro">
      <div className="container">
        <p className="intro-kicker">Ecossistema Convertrex</p>
        <h2 className="intro-title">{t('intro.title')}</h2>
        <p className="intro-text">{t('intro.complement')}</p>
        <div className="intro-actions">
          <a href="#solutions" className="intro-btn intro-btn--primary">
            {t('intro.ctaPrimary')}
          </a>
          <Link to="/planos" className="intro-btn intro-btn--ghost">
            {t('intro.ctaSecondary')}
          </Link>
        </div>
        <div className="intro-stats">
          <div>
            <strong>Módulo comercial</strong>
            <span>Converlead — leads e conversão</span>
          </div>
          <div>
            <strong>Módulo operacional</strong>
            <span>AXYS — agenda e gestão</span>
          </div>
          <div>
            <strong>Ecossistema</strong>
            <span>Convertrex conecta os dois</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
